import React, { useEffect } from 'react';
import { Col, Form, Input, notification, Radio, Row } from 'antd';
import { connect } from 'dva';
import { ReloadOutlined, SearchOutlined } from '@ant-design/icons';

import { StyledButton } from '../styles';
import { DEVICE, USER_PROFILE, SWID, FUBO_USER, VIEWER_ID } from '../../../constants';
import {
  ADINVESTIGATOR_VIEW_RULES_DEVICE,
  ADINVESTIGATOR_VIEW_RULES_SELECT_OVERRIDEBY,
  ADINVESTIGATOR_VIEW_RULES_SUBMIT,
  ADINVESTIGATOR_VIEW_RULES_USERPROFILE,
} from '../../../testUtils';
import { FORM_NOT_EMPTY_RULE } from '../../../utils';

const RuleSearch = ({ dispatch, overrideBy, setOverrideBy, searchParams = {} }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    // Update the local state when the overrideBy prop changes
    form.setFieldsValue({ overrideBy: overrideBy });
  }, [form, overrideBy]);

  const changeOverrideBy = ({ target }) => {
    setOverrideBy(target.value);
    dispatch({
      type: 'app/setSearchParams',
      payload: { ...searchParams, viewType: target.value },
    });
    dispatch({ type: 'adInvestigator/fetchExistingRules', payload: { overrideBy: target.value } });
  };

  const refreshRules = () => {
    dispatch({ type: 'adInvestigator/fetchExistingRules', payload: { overrideBy } });
    notification.success({
      message: 'Refreshed',
      duration: 3,
    });
  };

  const findRules = (values) => {
    dispatch({ type: 'adInvestigator/fetchExistingRules', payload: values });
    notification.success({
      message: 'Rules looked up',
      duration: 3,
    });
  };

  const selectOverrideBy = (
    <Col span={24} data-testid={ADINVESTIGATOR_VIEW_RULES_SELECT_OVERRIDEBY}>
      <Form.Item label="Search By" name="overrideBy">
        <Radio.Group optionType="button" onChange={changeOverrideBy}>
          <Radio value={USER_PROFILE}>User/Account</Radio>
          <Radio value={DEVICE}>Device</Radio>
          <Radio value={SWID}>SWID</Radio>
          <Radio value={FUBO_USER}>Fubo User</Radio>
          <Radio value={VIEWER_ID}>MLB Viewer</Radio>
        </Radio.Group>
      </Form.Item>
    </Col>
  );

  const submit = (
    <>
      <Col data-testid={ADINVESTIGATOR_VIEW_RULES_SUBMIT}>
        <Form.Item>
          <StyledButton icon={<SearchOutlined />} type="primary" htmlType="submit" />
        </Form.Item>
      </Col>
      <Col>
        <StyledButton type="primary" onClick={refreshRules} icon={<ReloadOutlined />}>
          Refresh
        </StyledButton>
      </Col>
    </>
  );

  return (
    <Form form={form} onFinish={findRules} initialValues={{ overrideBy: overrideBy }}>
      <Row gutter={4}>{selectOverrideBy}</Row>
    </Form>
  );
};

function mapStateToProps({ app }) {
  return {
    searchParams: app.searchParams,
  };
}

export default connect(mapStateToProps)(RuleSearch);
